<template>
    <section id="partner" class="partner">
        <div class="container">
            <h3 class="partner-title">
                {{ $t('partner.main_title') }}
            </h3>
            <div class="content">
                <div class="row" style="row-gap: 50px;">
                    <div class="col-lg-4 col-sm-4" v-for="(item, index) in $store.state.partner_data" :key="index"
                        v-scrollanimation>
                        <img :src="item.image" class="partner-logo" :alt="item.name" height="100%" width="100%" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>


export default {
    name: "Partner",
    components: {

    },
    data() {
        return {
            screenWidth: 0,
            size: 0,
            partner_data: [
                "partner1.webp",
                "partner2.webp",
                "partner3.webp",
            ]
        };
    },
    methods: {
        getImage(item) {
            return require("@/assets/img/partner/" + item)
        },
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateScreenWidth();
            });
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth
        },
        setSize() {
            if (this.screenWidth >= '992')
                this.size = 3
            else
                this.size = 1
        },
        viewDetails(item) {
            this.$router.replace({ name: 'partner', params: { id: item.id } })
        },

    },

    created() {
        this.updateScreenWidth()
        this.onScreenResize()
        this.setSize()
    },
};
</script>

<style lang="scss">
.partner {
    padding: 60px 100px 80px;
    background-color: rgba(231, 231, 231, 0.356);
}

@media (max-width: 991px) {
    .partner {
        padding: 60px 30px 80px;
    }
}

// @media (max-width: 575px) {
//     .partner .partner-logo {
//         width: 40% !important
//     }
// }

.partner .partner-title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    color: var(--main-blue);
    margin-bottom: 60px;
}

// .partner .VueCarousel-dot[data-v-438fd353]:focus {
//     outline: 1px solid var(--main-blue);
// }

// .partner .VueCarousel-slide {
//     padding: 10px
// }
@media (min-width: 992px) {
    .partner .partner-logo {
        width: 40%;
    }
}
@media (max-width: 991px) {
    .partner .partner-logo {
        width: 80%;
    }
}
@media (max-width: 567px) {
    .partner .partner-logo {
        width: 30%;
    }
}
.partner .partner-logo {
    box-shadow: 0 0 10px #00000044;
    transition: all .5s;
}

.partner .partner-logo:hover {
    box-shadow: 0 0 20px #00000044;
    transform: scale(1.1, 1.1);
    // cursor: pointer;
    transition: all .5s;

}

.partner .before-enter {
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
    transition: all .8s ease-in;
}

.partner .enter {
    opacity: 1;
    transform: scale3d(1, 1, 1);
    // transform: translateY(0px);
}
</style>